export function getCookie(cookieName: string): string | null {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim();

    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length);
    }
  }

  return null;
}

export function deleteCookie(name: string): void {
  const pastDate = new Date(0);
  document.cookie = `${name}=; expires=${pastDate.toUTCString()}; path=/`;
}

export function setCookie(name: string, value: string, expiryDays = 365): void {
  const date = new Date();
  date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);

  const expires = `expires=${date.toUTCString()}`;
  const decodedValue = decodeURIComponent(value);

  const domain = window.location.hostname.includes('embarkvet.com')
    ? '.embarkvet.com'
    : window.location.hostname;

  document.cookie = `${name}=${decodedValue}; expires=${expires}; domain=${domain}; path=/`;
}
